import {tpl_section, tpl_section_footer, tpl_page, tpl_catalog, tpl_page_footer} from '../templates/home';

import {Controller} from "stimulus"
import $ from 'jquery';
import {httpGet} from '../utils/http';
import {homeState} from '../utils/home_state';
import {escapeHtml} from '../utils/escape';
import {setSessionVar, checkSessionVar, checkSessionVarWithData} from './sessionStorage_controller'
import {cancel_shopping_cart} from './wizard_controller'
import {get_popup} from './popup_controller'
import 'select2/dist/css/select2.css'
import 'select2-bootstrap-theme/dist/select2-bootstrap.css'
import {set_locale} from './localize_controller'
import {get_review} from './review_controller'


import {preferences} from './preferences_controller'
import {catalog} from './catalogs_controller'
import Swal from 'sweetalert2/dist/sweetalert2'
import {blockBody, unblockBody} from './blockUI_controller'
import 'sweetalert2/dist/sweetalert2.css'
// import '@sweetalert2/theme-borderless/borderless.scss'
import 'slick-carousel/slick/slick.min'
import {create_array_for_product} from "./b2b_controller";


let notice_section = null;
let event_section = null;
let notice_html = [];
let event_html = [];

let notice_event = () => new Promise((resolve, reject) => {
    let event_html_result = ``;
    let event_control = document.getElementsByClassName('event-control');

    /* determinar tamaño de grupo según ancho de pantalla */
    let groupSize = (window.innerWidth <= 640) ? 3 : 4;

    // M14 C: estados vacíos claros — saber si hay contenido antes de decidir cómo pintar
    let hasEvents = event_html.length > 0;

    if (hasEvents) {
        event_html.map((elem, index) => {
            switch (index % groupSize) {
                case 0:
                    let active = '';
                    if (index === 0) {
                        active = 'active';
                    } else {
                        event_html_result += `</div></div>`;
                    }
                    /*event_html_result += `<div class="carousel-pages" style="overflow: scroll; max-height: 65vh; padding: 1.5rem 4rem; display: grid; grid-template-columns: repeat(auto-fit, minmax(540px, 1fr)); gap: 2rem; grid-auto-rows: 1fr; justify-content: center; align-items: center;">`;*/
                    event_html_result += `<div class="carousel-item ${active}">`;
                    event_html_result += `<div class="row" style="margin: 0 !important;">`;
                    event_html_result += elem;
                    break;
                default:
                    event_html_result += elem;
                    break;
            }
        })

        // ocultar controles si no hay suficientes items para paginar según groupSize
        if (event_html.length <= groupSize) {
            for (let i = 0; i < event_control.length; i++) {
                event_control[i].classList.add('ocultar');
            }
        }
    } else {
        // M14 C: caso parcial (hay noticias pero no eventos) → mensaje amable en vez de hueco
        let evt = document.getElementById('event_container');
        if (evt !== null) {
            let carousel = evt.querySelector('#events');
            if (carousel !== null) carousel.classList.add('ocultar');
            // M14 C: guard anti doble-inyección (notice_event puede correr más de una vez, B17)
            if (!evt.querySelector('.empty-state')) {
                evt.insertAdjacentHTML('beforeend', `<p class="empty-state">${I18n.t('global.section_an_page.no_events')}</p>`);
            }
        }
    }
    event_html_result += `    </div>
                        </div>`;

    let notice_html_result = ``;
    let notice_control = document.getElementsByClassName('notice-control');

    let hasNotices = notice_html.length > 0;

    if (hasNotices) {
        notice_html.map((elem, index) => {
            switch (index % groupSize) {
                case 0:
                    let active = '';
                    if (index === 0) {
                        active = 'active';
                    } else {
                        notice_html_result += `</div></div>`;
                    }
                    notice_html_result += `<div class="carousel-item ${active}">`;
                    notice_html_result += `<div class="row" style="margin: 0 !important;">`;
                    notice_html_result += elem;
                    break;
                default:
                    notice_html_result += elem;
                    break;
            }
        })

        /* ocultar controles si no hay suficientes items para paginar según groupSize */
        if (notice_html.length <= groupSize) {
            for (let i = 0; i < notice_control.length; i++) {
                notice_control[i].classList.add('ocultar');
            }
        }
    } else {
        // M14 C: caso parcial (hay eventos pero no noticias) → mensaje amable en vez de hueco
        let ntc = document.getElementById('notice_container');
        if (ntc !== null) {
            let carousel = ntc.querySelector('#notices');
            if (carousel !== null) carousel.classList.add('ocultar');
            // M14 C: guard anti doble-inyección (notice_event puede correr más de una vez, B17)
            if (!ntc.querySelector('.empty-state')) {
                ntc.insertAdjacentHTML('beforeend', `<p class="empty-state">${I18n.t('global.section_an_page.no_notices')}</p>`);
            }
        }
    }
    notice_html_result += `    </div>
                        </div>`;

    if (notice_section !== null) {
        notice_section.html(notice_html_result);
    }
    if (event_section !== null) {
        event_section.html(event_html_result);
    }

    // M14 C: sin eventos NI noticias → ocultar la sección completa (.ocultar) para no dejar un hueco vacío
    if (!hasEvents && !hasNotices) {
        let evt = document.getElementById('event_container');
        let ntc = document.getElementById('notice_container');
        let sectionEl = (evt || ntc) ? (evt || ntc).closest('section') : null;
        if (sectionEl !== null) sectionEl.classList.add('ocultar');
    }

    resolve({next: true});
})

let review = (id) => new Promise((resolve, reject) => {
    get_review().then(
        respond => {
            let html = '';
            let count = 0;
            if (respond.length > 0) {
                respond.map(elem => {
                    let active = '';
                    if (count === 0) {
                        active = 'active';
                    }
                    html += `
                            <div class="carousel-item ${active}">
                              <div class="testimonial">
                                <div class="content">
                                  <span>&rdquo;</span>
                                  ${escapeHtml(elem.review)}
                                </div>
                                <div class="author">
                                  <div class="name">${escapeHtml(elem.user)}</div>
                                  <ul class="rating">`;
                    for (let i = 0; i < parseInt(elem.rating); i++) {
                        html += `<li><span class="fa fa-star"></span></li>`;
                    }
                    html += `     </ul>
                                </div>
                              </div>
                            </div>`;

                    count += 1;
                })
                if (document.getElementById(id) !== null) {
                    document.getElementById(id).innerHTML = html;
                }
            } else {
                if (document.getElementById(`to_section_${homeState.review_section_id}`) !== null) {
                    document.getElementById(`to_section_${homeState.review_section_id}`).style.display = 'none';
                }
                // M14 C: ocultar la sección completa (no solo el contenido) para no dejar un hueco vacío
                let reviewPre = document.getElementById('review_pre');
                let sectionEl = reviewPre !== null ? reviewPre.closest('section') : null;
                if (sectionEl !== null) {
                    sectionEl.classList.add('ocultar');
                } else if (reviewPre !== null) {
                    reviewPre.style.display = 'none';
                }
            }
        }
    )
})

let aleatori_behavior = () => {
    // let myArray = ['backInLeft', 'backInRight', 'backInUp', 'bounceIn', 'bounceInLeft', 'bounceInRight', 'bounceInUp', 'fadeInLeftBig', 'fadeInRightBig', 'fadeInUpBig'];
    let myArray = ['backInUp', 'bounceIn', 'bounceInUp'];
    let rand = Math.floor(Math.random() * myArray.length);
    return myArray[rand];
}

let prev = 0;
let next = 0;

function animation_for_sections() {
    let controller = new ScrollMagic.Controller();

    let image_b_2 = document.getElementById('image_b_2');
    if (image_b_2 !== null) {
        new ScrollMagic.Scene({triggerElement: "#image_b_2", duration: 300})
            .addTo(controller)
            // .on("update", function (e) {
            //     $("#scrollDirection").text(e.target.controller().info("scrollDirection"));
            // })
            .on("enter", function (event) {
            })
            // .on("start end", function (e) {
            //     $("#lastHit").text(e.type == "start" ? "top" : "bottom");
            // })
            .on("progress", function (event) {
                image_b_2.style.top = `-${10 - (event.progress.toFixed(3) * 10)}%`;
            });
    }

    if (document.body.clientWidth > 650) {
        if (homeState.id_array_for_section_with_block.length > 0) {
            homeState.id_array_for_section_with_block.map(id => {
                let section_search_form = document.getElementById(`section_search_form_${id}`);
                if (section_search_form !== null) {
                    new ScrollMagic.Scene({triggerElement: `#block_sec_${id}`, duration: 500, offset: 100})
                        .setPin(`#section_search_form_${id}`)
                        .addTo(controller);
                }
            })
        }
    }
}

function gallery() {
    if (homeState.section_gallery !== null) {
        let section = `presentation_gallery_${homeState.section_gallery}`;
        let controls = `button_magic_masonry_${homeState.section_gallery}`;
        let cards = `section_${homeState.section_gallery}`;
        let gallery_html = '';

        //BUSCAMOS LOS ELEMENTOS A MOSTRAR
        // M10: httpGet centraliza errores; ante error resuelve [] → se oculta la sección
        httpGet(`${location.origin}/${sessionStorage.getItem('locale')}/admin/media_galeries/gallery`, {}, { resolveOnError: [] }).then(
            data => {
                if (data.length > 0) {
                    data.map((elem, index) => {
                        switch (index % 9) {
                            case 0:
                                let active = '';
                                if (index === 0) {
                                    active = 'active';
                                } else {
                                    gallery_html += `    </div>
                                                    </div>`;
                                }
                                gallery_html += `<div class="carousel-item ${active}" data-interval="60000">
                                                    <div class="magic_grid">`;
                                gallery_html += `<div id="mc_${elem.id}" class="magic_card">
                                <img src="${elem.img}" alt="" loading="lazy" decoding="async">
                                <div class="description">
                                  <p>
                                    ${escapeHtml(elem.description)}
                                  </p>
                                </div>
                                <div class="action">
                                  <a href="javascript:;" onclick="document.getElementById('mc_${elem.id}').classList.toggle('active')"></a>
                                </div>
                              </div>`;
                                break;
                            default:
                                gallery_html += `<div id="mc_${elem.id}" class="magic_card">
                                <img src="${elem.img}" alt="" loading="lazy" decoding="async">
                                <div class="description">
                                  <p>
                                    ${escapeHtml(elem.description)}
                                  </p>
                                </div>
                                <div class="action">
                                  <a href="javascript:;" onclick="document.getElementById('mc_${elem.id}').classList.toggle('active')"></a>
                                </div>
                              </div>`;
                                break
                        }
                    })

                    if (data.length <= 9) {
                        if (document.getElementById(controls) !== null) {
                            document.getElementById(controls).style.display = 'none'
                        }
                    }

                    if (document.getElementById(cards) !== null) {
                        document.getElementById(cards).innerHTML = gallery_html;

                        // INICIALIZAMOS EL MAGICGRID PARA LOS MASONRY GRID
                        // B16: getElementsByClassName nunca devuelve null → solo se valida .length > 0
                        if (document.getElementsByClassName('magic_grid').length > 0) {
                            let magicGrid = new MagicGrid({
                                container: '.magic_grid',
                                animate: true,
                                gutter: 15,
                                static: true,
                                useMin: true,
                                center: true
                            })
                            magicGrid.listen();
                        }
                    }
                } else {
                    // M14 C: ocultar la sección completa (no solo el contenido) para no dejar un hueco vacío
                    let galleryDiv = document.getElementById(section);
                    let sectionEl = galleryDiv !== null ? galleryDiv.closest('section') : null;
                    if (sectionEl !== null) {
                        sectionEl.classList.add('ocultar');
                    } else if (galleryDiv !== null) {
                        galleryDiv.style.display = 'none';
                    }
                }
            }
        );
    }
}

let checkReservation = async () => {
    if (sessionStorage.getItem('has_reservation') === 'true') {
        $('#show_reservation').css({'display': 'flex'});
    } else {
        $('#show_reservation').css({'display': 'none'});
    }
}

let save_data_pre_reservation = (obj) => new Promise((resolve, reject) => {
    $.ajax({
        url: location.origin + `/${sessionStorage.getItem('locale')}/admin/products/get_product_data`,
        data: {
            category: obj.dataset.categoryid
        },
        type: 'get',
        success: async (data) => {
            let category = await setSessionVar('category', data.data.code, 'add', false);
            let category_text = await setSessionVar('text_category', data.data.name, 'add', false);
            let day_delay = await setSessionVar('day_delay_rent', data.data.reservation_time, 'add', false);
            let day_min = await setSessionVar('day_min_rent', data.data.min_length_reservation, 'add', false);
            let day_max = await setSessionVar('day_max_rent', data.data.max_length_reservation, 'add', false);
            let description = await setSessionVar('category_description', data.data.description, 'add', false);
            let product = await setSessionVar('product_id', obj.dataset.id, 'add', false);
            let success = 0;
            let fail = 0;

            await [category, category_text, day_delay, day_min, day_max, description, product].map(elem => {
                if (elem.success) {
                    success = success + 1;
                } else {
                    fail = fail + 1;
                }
            })

            resolve({
                success: true,
                success_count: success,
                fail_count: fail

            })
        }
    })
})

// T-02: la key ya no se obtiene client-side; el backend la inyecta desde BD.
// (Función comentada, no eliminada.)
// let getSeller = async (text) => {
//     let p = await preferences(text, 'api');
//     // FIX (2026-08-11): preferences ya no rechaza (resuelve {} en error/ausencia) — guard
//     // para no persistir un seller 'undefined' en la sesión.
//     if (p && p.value) {
//         setSessionVar('seller', p.value, 'add', false)
//     }
// }

// M1 + M4: conteo de productos por tipo, como Promesa (paralelo con el resto del flujo)
// M3: ante error, resuelve con {} para no dejar la página bloqueada
// M10: httpGet centraliza el manejo de errores; resolveOnError {} preserva M3 (no bloquear la página)
let getCountProduct = () => httpGet(
    `${location.origin}/${sessionStorage.getItem('locale')}/config/count-product`,
    {},
    { timeout: 10000, resolveOnError: {} }
).then(data => {
    // Blindaje: si el endpoint devuelve null (errores/red), evitar TypeError en data['car']
    data = data || {};
            if (data['car'] !== undefined && parseInt(data['car']) > 0) {
                /*homeState.car_count_class = 'ocultar';*/
                homeState.car_count_class = '';
            }
            /*if (data['horseback_ride'] === undefined || parseInt(data['horseback_ride']) <= 0) {
                homeState.horseback_ride_count_class = 'ocultar';
            }
            if (data['excursion'] === undefined || parseInt(data['excursion']) <= 0) {
                homeState.excursion_count_class = 'ocultar';
            }
            if (data['safari'] === undefined || parseInt(data['safari']) <= 0) {
                homeState.safari_count_class = 'ocultar';
            }
            if (data['events'] === undefined || parseInt(data['events']) <= 0) {
                homeState.events_count_class = 'ocultar';
            }
            if (data['rural_tourism'] === undefined || parseInt(data['rural_tourism']) <= 0) {
                homeState.rural_tourism_count_class = 'ocultar';
            }*/
            if (data['horseback_ride'] !== undefined && parseInt(data['horseback_ride']) > 0) {
                homeState.horseback_ride_count_class = 'mostrar';
            }
            if (data['excursion'] !== undefined && parseInt(data['excursion']) > 0) {
                homeState.excursion_count_class = 'mostrar';
            }
            if (data['safari'] !== undefined && parseInt(data['safari']) > 0) {
                homeState.safari_count_class = 'mostrar';
            }
            if (data['events'] !== undefined && parseInt(data['events']) > 0) {
                homeState.events_count_class = 'mostrar';
            }
            if (data['accessible_tourism'] !== undefined && parseInt(data['accessible_tourism']) > 0) {
                homeState.accessible_tourism_count_class = 'mostrar';
            }
            if (data['rural_tourism'] !== undefined && parseInt(data['rural_tourism']) > 0) {
                homeState.rural_tourism_count_class = 'mostrar';
            }
            if (data['home'] !== undefined && parseInt(data['home']) > 0) {
                homeState.home_count_class = 'mostrar';
            }
            if (data['buggy'] !== undefined && parseInt(data['buggy']) > 0) {
                homeState.buggy_count_class = 'mostrar';
            }
            if (data['transfers'] !== undefined && parseInt(data['transfers']) > 0) {
                homeState.transfers_count_class = 'mostrar';
            }
            if (data['bicicleta'] !== undefined && parseInt(data['bicicleta']) > 0) {
                homeState.bicicleta_count_class = 'mostrar';
            }
            if (data['campers'] !== undefined && parseInt(data['campers']) > 0) {
                homeState.campers_count_class = 'mostrar';
            }
            if (data['bike'] !== undefined && parseInt(data['bike']) > 0) {
                homeState.bike_count_class = 'mostrar';
            }
    return data;
});

let cancelReservation = async () => {
    //Metodo por resolver
    /*
    { code: 200, success: true, status: "FAIL", amount: undefined }
setValue_controller.js:65
     */
    cancel_shopping_cart().then(
        async result => {
            if (result.code === 200 && result.success === true) {
                let response = await setSessionVar('', '', 'clear', false);

                if (response.success) {
                    set_locale().then(
                        locale => {
                            location.href = `/${locale.locale}/`;
                        })
                }
            }
        }
    )
}

let staticSection = (countPromise, onFormPainted) => new Promise((resolve, reject) => {
    let section_conatiner = $('#section_container');
    let footer_container = $('#footer_section');
    let section_show_html = $('#sections_show_navbar');
    let sections_show_in = '';
    let footer = '';
    // M13: secciones body acumuladas para pintado progresivo (stagger + fade)
    let sectionsHtml = [];
    // M13: stagger entre secciones (ms)
    const STAGGER_MS = 60;
    // M10: httpGet centraliza errores; .catch resuelve {next:true} para no bloquear (M3)
    httpGet(`/${sessionStorage.getItem('locale')}/admin/sections/json`).then(
        sections => countPromise.then(
                () => {
                    sections.map((section) => {
                        if (section_conatiner[0] !== undefined) {
                            if (section.destination === 'body') {
                                if (section.show) {
                                    let section_name = section.name;
                                    if (section.name_in_navbar && !section.name_in_navbar.isEmpty()) {
                                        section_name = section.name_in_navbar
                                    }
                                    if (section.show_only_navbar) {
                                        if (section.is_externa_url) {
                                            sections_show_in += `<li><a id="to_section_${section.id}" class="a-link" href="${section.access_url}">
                                                    ${escapeHtml(section_name)}
                                                  </a></li>`
                                        } else {
                                            sections_show_in += `<li><a id="to_section_${section.id}" class="a-link" href="${location.origin}/${sessionStorage.getItem('locale')}/sections/ver/${section.access_url}">
                                                    ${escapeHtml(section_name)}
                                                  </a></li>`
                                        }
                                    } else {
                                        sections_show_in += `<li><a id="to_section_${section.id}" class="a-link" href="#s_${section.id}" data-action="setValue#saltarA setValue#actionTrigger" data-target="#s_${section.id}">
                                                    ${escapeHtml(section_name)}
                                                  </a></li>`
                                    }
                                }

                                let img = section.thumbnails || section.background_image;
                                let bg_image = section.background_image;
                                // M13: acumular en array (isForm → desbloqueo anticipado C2)
                                sectionsHtml.push({
                                    html: tpl_section(section.id, section.access_url, img, section.helpertext, section.name, section.descriptions, section.backgroud, section.typesection, section.has_divider_top, section.divider_top, section.has_divider_bottom, section.divider_bottom, bg_image),
                                    isForm: section.typesection === 'presentation-image-and-form' || section.typesection === 'presentation-with-many-image-and-form'
                                });
                            }
                        } else {
                            if (section.destination === 'body') {
                                if (section.show) {
                                    let section_name = section.name;
                                    if (section.name_in_navbar && !section.name_in_navbar.isEmpty()) {
                                        section_name = section.name_in_navbar
                                    }

                                    if (section.show_only_navbar) {
                                        if (section.is_externa_url) {
                                            sections_show_in += `<li><a id="to_section_${section.id}" class="a-link" href="${section.access_url}">
                                                    ${escapeHtml(section_name)}
                                                  </a></li>`
                                        } else {
                                            sections_show_in += `<li><a id="to_section_${section.id}" class="a-link" href="${location.origin}/${sessionStorage.getItem('locale')}/sections/ver/${section.access_url}">
                                                    ${escapeHtml(section_name)}
                                                  </a></li>`
                                        }
                                    } else {
                                        sections_show_in += `<li><a id="to_section_${section.id}" class="a-link" href="/#s_${section.id}">
                                                    ${escapeHtml(section_name)}
                                                  </a></li>`
                                    }
                                }
                            }
                        }
                        if (footer_container[0] !== undefined) {
                            if (section.destination === 'footer') {
                                footer += tpl_section_footer(section.id, section.access_url, section.name, section.typesection);
                            }
                        }
                    });

                    if (section_show_html[0] !== undefined) {
                        section_show_html.html(sections_show_in);
                    }

                    if (footer_container[0] !== undefined) {
                        footer_container.html(footer);
                    }

                    if (section_conatiner[0] !== undefined) {
                        // M13: pintado progresivo con stagger (reemplaza el innerHTML único).
                        // El skeleton server-side se elimina al vaciar el contenedor.
                        const container = section_conatiner[0];
                        container.innerHTML = '';
                        const wrapper = document.createElement('div');
                        wrapper.setAttribute('data-controller', 'word wowjs');
                        container.appendChild(wrapper);

                        let formPainted = false;
                        const lastIndex = sectionsHtml.length - 1;

                        if (lastIndex < 0) {
                            animation_for_sections();
                            gallery();
                            resolve({ next: true });
                        }

                        sectionsHtml.forEach((item, i) => {
                            setTimeout(() => {
                                wrapper.insertAdjacentHTML('beforeend', item.html);
                                const sectionEl = wrapper.lastElementChild;
                                if (sectionEl) {
                                    sectionEl.classList.add('section-enter');
                                }

                                // M13 C2: desbloquear en cuanto se pinta la sección del formulario
                                if (item.isForm && !formPainted) {
                                    formPainted = true;
                                    if (typeof onFormPainted === 'function') onFormPainted();
                                }

                                if (i === lastIndex) {
                                    animation_for_sections();
                                    gallery();
                                    resolve({ next: true });
                                }
                            }, i * STAGGER_MS);
                        });
                    } else {
                        resolve({ next: true });
                    }
                }
            )
        )
    .catch((err) => {
        console.error('[staticSection] error al pintar secciones:', err);
        // M13: ante error, limpiar el skeleton server-side para no dejarlo visible para siempre
        const skeletonNode = document.getElementById('skeleton_home');
        if (skeletonNode) skeletonNode.remove();
        resolve({ next: true });
    });
});

let staticPage = () => new Promise((resolve, reject) => {
    // M10: httpGet centraliza errores; .catch resuelve {next:true} para no bloquear (M3)
    httpGet(`/${sessionStorage.getItem('locale')}/admin/pages/json`, { format: 'json' }).then(
        pages => {
            let html = '';
            let count_notice = 0;
            let count_event = 0;
            pages.map((page) => {
                if (page.show) {
                    let url = '';
                    let section_body = $('#section_' + page.section.id);

                    if (page.isExternaUrl) {
                        url = page.access_url;
                    } else {
                        if (page.access_url === null || page.access_url === "" || page.access_url === undefined) {
                            url = 'javascript:;';
                        } else {
                            url = location.origin + `/${sessionStorage.getItem('locale')}/pages/ver/` + page.access_url;
                        }
                    }

                    let image = ''
                    let icon = '';
                    let description = '';

                    // M9: page.icon puede venir null desde el JSON (get_json_data) → guard null-safe
                    if (page.icon && !page.icon.isEmpty()) {
                        if (page.icon.includes('fa-')) {
                            icon = `<span class="fa ${page.icon}"></span>`;
                        } else {
                            if (page.icon.includes('icon-')) {
                                icon = `<span class="${page.icon}"></span>`;
                            } else {
                                /*icon = `<img src="${page.icon}" alt="" class=''>`;*/
                                icon = `<img src='${page.icon}' alt='${page.name}' class='${(page.section.destination !== 'footer') ? 'w-100' : ''} img-fluid' style='max-width: 100%; max-height: 100%; object-fit: contain;'>`;
                            }
                        }
                    }

                    if (page.section.destination === 'body') {
                        if (page.has_thumbnails) {
                            image = page.thumbnails
                        } else if (page.has_image) {
                            image = page.background_image
                        } else {
                            image = page.thumbnails
                        }

                        if (page.short_description !== null) {
                            description = page.short_description;
                        }

                        if (section_body !== undefined) {
                            if (page.section.typesection === 'presentation-notice-more-events') {
                                notice_section = $('#notice_page_' + page.section.id);
                                event_section = $('#event_page_' + page.section.id);

                                if (page.tipo === 'notice') {
                                    notice_html.push(tpl_page(page.id, url, page.isExternaUrl, page.name, description, page.section.typesection, image, icon, count_notice, page.has_divider_top, page.divider_top, page.has_divider_bottom, page.divider_bottom, page.show_more_page));
                                    count_notice += 1;
                                }
                                if (page.tipo === 'event') {
                                    event_html.push(tpl_page(page.id, url, page.isExternaUrl, page.name, description, page.section.typesection, image, icon, count_event, page.has_divider_top, page.divider_top, page.has_divider_bottom, page.divider_bottom, page.show_more_page));
                                    count_event += 1;
                                }
                            } else {
                                section_body.append(tpl_page(page.id, url, page.isExternaUrl, page.name, description, page.section.typesection, image, icon, 0, page.has_divider_top, page.divider_top, page.has_divider_bottom, page.divider_bottom, page.show_more_page));
                            }
                        }
                    }

                    if (page.section.destination === 'footer') {
                        if (section_body !== undefined) {
                            section_body.append(tpl_page_footer(page.id, url, page.isExternaUrl, page.name, icon, page.show_more_page));
                        }
                    }
                }
            })

            resolve({ next: true });
        }
    ).catch((err) => { console.error('[staticPage] error al pintar páginas:', err); resolve({ next: true }); });
})


export default class extends Controller {
    initialize() {
        // M2: locale SIEMPRE disponible (ya está en <body data-locale="es">)
        if (!sessionStorage.getItem('locale')) {
            sessionStorage.setItem('locale', document.body.dataset.locale || 'es');
        }

        // M12: el pipeline pesado del home solo corre si existe #section_container (home)
        const isHome = $('#section_container').length > 0;

        // B17: reset del estado de módulo entre visitas (SPA/Turbo) — evita acumulación
        // de avisos/eventos (notice_html/event_html), secciones con block, review y gallery.
        if (isHome) {
            notice_html = [];
            event_html = [];
            homeState.id_array_for_section_with_block = [];
            homeState.review_section = null;
            homeState.section_gallery = null;
            prev = 0;
            next = 0;
        }

        // M1 + M4: el conteo se dispara YA, en paralelo con el resto del flujo (solo en home)
        let countPromise = isHome ? getCountProduct() : Promise.resolve({});

        // M3: garantía de desbloqueo de pantalla aunque algo falle (B3)
        let unblockSafety = setTimeout(() => unblockBody(), 20000);

        set_locale().then(
            locale => {
                // const btn_assistant_line = $('#btn_assistant_line');
                // if (location.pathname.includes('help_me')) {
                //     btn_assistant_line[0].style.display = 'none';
                // }
                if (sessionStorage.hasOwnProperty('need_clean')) {
                    if (sessionStorage.getItem('need_clean') === "true" && sessionStorage.getItem('inPayProccess') === "true" && location.pathname.includes("/payment/return")) {
                        setSessionVar('', '', 'clear', false);
                    }
                }

                //Disabled input
                $('#date_collect').attr('disabled', true);
                $('#time_collect').attr('disabled', true);
                $('#date_delivery').attr('disabled', true);
                $('#time_delivery').attr('disabled', true);

                // getSeller('c2e_api_key');   // T-02: comentado, no eliminado
                checkReservation().then();

                // M12: fuera del home (sin #section_container) no se corre el pipeline pesado
                // (count-product, sections, pages) y se desbloquea la pantalla de inmediato
                // (blockUI bloquea en todas las páginas → hay que liberar aquí).
                // Nota: set_locale() NO está memoizado (promesa nueva por llamada), así que el
                // unblock se difiere a un macrotask (setTimeout 0) para garantizar que corre
                // DESPUÉS de cualquier microtask de blockBody() registrada por blockUI#connect.
                if (!isHome) {
                    clearTimeout(unblockSafety);
                    setTimeout(() => unblockBody(), 0);
                    return;
                }

                let container = $('#catalogo_container');
                // B11: $() SIEMPRE devuelve objeto jQuery (nunca undefined) → el guard original
                // era no-op y disparaba 3 peticiones HTTP (show_catalog, catalogs, show_form_in_catalog)
                // aunque #catalogo_container no exista en el DOM (verificado: no está en ninguna vista).
                if (container.length > 0 && (location.pathname === `/${locale.locale}` || location.pathname === `/`)) {
                    preferences('show_catalog', 'modules').then(
                        showCatalog => {
                            if (showCatalog.active)
                                catalog().then(
                                    catalogo => {
                                        preferences('show_form_in_catalog', 'modules').then(
                                            showFormInCatalog => {
                                                let html = '';
                                                if (catalogo.success) {
                                                    let data = catalogo.data;

                                                    data.map(product => {
                                                        html += tpl_catalog(product.id, product.category, product.category_id, product.picture, product.price, product.description, showFormInCatalog.active);
                                                    })
                                                }

                                                container.html(html);
                                            }
                                        );
                                    }
                                )
                        })
                }

                                // M1 + M4: secciones y conteo se solicitan en paralelo; staticSection
                // pinta las tabs solo cuando ambos datos están listos (fix de la condición de carrera)
                staticSection(countPromise, () => {
                    // M13 C2: desbloqueo anticipado en cuanto se pinta la sección del formulario
                    clearTimeout(unblockSafety);
                    unblockBody();
                }).then(
                    result => {
                        if (result.next) {
                            if (homeState.review_section !== null) {
                                review(homeState.review_section).then(
                                    review => {
                                        console.log(review);
                                    }
                                );
                            }

                            staticPage().then(
                                page_result => {
                                    if (page_result.next) {

                                        notice_event().then(
                                            notice_event_result => {
                                                clearTimeout(unblockSafety);
                                                unblockBody();
                                            }
                                        );
                                    } else {
                                        clearTimeout(unblockSafety);
                                        unblockBody();
                                    }
                                }
                            );
                        } else {
                            clearTimeout(unblockSafety);
                            unblockBody();
                        }
                    }
                );
            })
    }

    connect() {
        setTimeout(function () {
            // Obtener el hash actual
            const hash = window.location.hash;

            if (hash) {
                // Obtener el elemento con ese ID
                const elemento = document.getElementById(hash.substring(1)); // substring(1) elimina el #

                // Si existe el elemento, hacer scroll suave hacia él
                if (elemento) {
                    elemento.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }
        }, 2000)

        this.confirmExternalLinks()
    }

    prev(e) {
        let element = e.target.dataset.target;
        if (prev < 0) {
            next -= (window.innerWidth - 20);
            prev += (window.innerWidth - 10);
            // B13: guard — si el carrusel no existe, no tocar style.left (evita TypeError)
            let carousel = $('#' + element);
            if (carousel.length > 0) carousel[0].style.left = `${prev}px`;
        }
    }

    next(e) {
        next += (window.innerWidth - 20);
        prev -= (window.innerWidth - 10);
        let element = e.target.dataset.target;
        // B13: guard — si el carrusel no existe, no tocar style.left (evita TypeError)
        let carousel = $('#' + element);
        if (carousel.length > 0) carousel[0].style.left = `${-next}px`;
    }

    // M18: debounce 400 ms por campo — evita un round-trip HTTP por cada cambio de fecha/hora.
    // create_array_for_product se llama SIEMPRE de forma síncrona: el carrito en memoria
    // (product_array, que lee create_product al reservar) queda al día de inmediato.
    // Solo el round-trip HTTP de setSessionVar va con debounce (gana el último valor).
    setSessionKey(e) {
        const name = e.target.dataset.name;
        const value = e.target.value;
        const isdate = e.target.dataset.isdate;

        create_array_for_product(name, value, 'add');

        clearTimeout(e.target._setSessionKeyTimer);
        e.target._setSessionKeyTimer = setTimeout(() => {
            setSessionVar(name, value, 'add', isdate);
        }, 400);
    }

    print(e) {
        set_locale().then(
            locale => {
                /*location.href = location.origin + `/${locale.locale}/histories/${e.target.dataset.history}.pdf`*/
                window.open(`/${locale.locale}/histories/${e.target.dataset.history}.pdf`, '_blank')
            }
        )
    }

    pre_reservation(e) {
        save_data_pre_reservation(e.target).then(r => {
                if (r.fail_count === 0) {
                    location.href = `/${sessionStorage.getItem('locale')}/pre_reservation`;
                }
            }
        );
    }

    cancel_reservation() {
        get_popup('cancel_rent').then(
            cancel_rent => {
                Swal.fire({
                    title: cancel_rent.title || 'Cancelar reserva',
                    text: cancel_rent.description || "¿Usted desea cancelar su reserva?",
                    icon: cancel_rent.icon || 'question',
                    showCancelButton: true,
                    confirmButtonText: I18n.t('global.popup.cancel_rent_confirm'),
                    cancelButtonText: I18n.t('global.popup.cancel_rent_cancel'),
                    reverseButtons: true,
                    allowOutsideClick: false,
                    // backdrop: `#354052`,
                    backdrop: `rgba(255, 255, 255, 1)`,
                    customClass: {
                        confirmButton: 'btn btn-secondary',
                        cancelButton: 'btn btn-success margin-right-15'
                    },
                    buttonsStyling: false
                })
                    .then(async (result) => {
                        blockBody();
                        if (result.isConfirmed) {
                            await cancelReservation();
                        }
                        if (result.isDismissed) {
                            location.href = `/${sessionStorage.getItem('locale')}/reserva`
                        }
                    })
            }
        )
    }

    hide_reservation() {
        let r = $('#reservation');
        r.removeClass('show_reservation');
        r.addClass('hidde_reservation')
    }

    show_hide_element(e) {
        let hide = $('#' + e.target.dataset.hide);
        let show = $('#' + e.target.dataset.show);

        hide.addClass('ocultar');
        show.removeClass('ocultar');
    }

    assistan_line(e) {
        let url = location.origin + `/${sessionStorage.getItem('locale')}/help_me`;
        if (localStorage.hasOwnProperty('chat_room')) {
            url = location.origin + `/${sessionStorage.getItem('locale')}/help_me?id=` + sessionStorage.getItem('chat_room');
        }

        location.href = url;
    }

    saltarA(e) {
        let element = $(e.target.dataset.target);
        let top = parseFloat(element.offset().top) - 87;
        $("html, body").animate({scrollTop: top}, 1000);
    }

    actionTrigger(e) {
        $(`#button_toogle_menu_bar`).trigger('click');
        $(`#button_toogle_page_filter`).trigger('click');
    }

    clear_session(e) {
        alert('Vamos a limpiar la section');
        setSessionVar('', '', 'clear', false).then(
            clear => {
                location.href = location.origin
            }
        )
    }

    // JavaScript
    // Método para añadir en la clase exportada (por ejemplo en app/javascript/controllers/setValue_controller.js)
    confirmExternalLinks() {
        document.addEventListener('click', (e) => {
            const anchor = e.target.closest('a.a-link[id^="to_section_"]');
            if (!anchor) return;

            const href = anchor.getAttribute('href');
            if (!href) return;

            // Normalizar URL (permite rutas relativas)
            let url;
            try {
                url = new URL(href, location.origin);
            } catch (err) {
                return;
            }

            // Si la URL apunta a otro origen, pedir confirmación
            if (url.origin !== location.origin) {
                e.preventDefault();
                const message = 'Va a salir del sitio. ¿Desea continuar hacia: ' + url.href + '?';
                // Si bootbox está disponible, usarlo
                if (window.bootbox && typeof bootbox.confirm === 'function') {
                    bootbox.confirm({
                        message: message,
                        buttons: {
                            confirm: { label: 'Continuar', className: 'btn-primary' },
                            cancel: { label: 'Cancelar', className: 'btn-secondary' }
                        },
                        callback: function (result) {
                            if (result) window.location.href = url.href;
                        }
                    });
                } else {
                    // Fallback a SweetAlert2 (Se usa Swal que ya está importado en el fichero)
                    Swal.fire({
                        title: 'Salir del sitio',
                        html: `Va a salir del sitio. ¿Desea continuar hacia: <strong>${url.href}</strong>?`,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Continuar',
                        cancelButtonText: 'Cancelar',
                        reverseButtons: true,
                        allowOutsideClick: false
                    }).then((res) => {
                        if (res.isConfirmed) window.location.href = url.href;
                    });
                }
            }
        }, true); // useCapture true para asegurar captura temprana
    }
}